




















































import { Component, Prop, Vue } from 'vue-property-decorator'
import { ModuleOption, InformationCodes } from '@/data/enums'
import OptionModule from '@/components/OptionModule.vue'
import GlassOptionValue from '@/data/glass-option-value'
import '@/icons/options-color'
import GlassOption from '@/data/glass-option'

@Component({
  components: {
    OptionModule
  }
})
export default class ColorModule extends Vue {
  @Prop() private optionId!: ModuleOption
  private colorSetRoute?: string = ''
  private informationCode: string = InformationCodes.ModuleColor

  private get currentOption (): GlassOption | undefined {
    if (this.$store.state.cart.currentItem && this.$store.state.cart.currentItem.type) {
      return this.$store.state.cart.currentItem.type.options
        .find((option: GlassOption) => option.optionId === this.optionId)
    }
  }

  private get nextPage () {
    if (this.currentOption) {
      const optionValue = this.currentOption.values
        .find((value: GlassOptionValue) => (value.selected))
      if (optionValue) {
        return `/glasses/color/${this.colorSetName(optionValue.number)}`
      }
    }
  }

  private colorSetImage (valueNumber: number) {
    return `module/color/color_${this.colorSetName(valueNumber)}.png`
  }

  private colorSetName (valueNumber: number) {
    switch (valueNumber) {
      case 41:
      case 61:
        return 'uni'
      case 42:
      case 62:
        return 'degrade'
      case 43:
      case 63:
        return 'polarized'
      case 44:
      case 64:
        return 'contrast'
      default:
        return ''
    }
  }

  private toggleOptionValue (optionValue: GlassOptionValue) {
    this.colorSetRoute = `/glasses/color/${this.colorSetName(optionValue.number)}`
    this.$store.dispatch('cart/toggleOptionValue', optionValue)
      .catch((err) => console.error(err))
  }
}
